import fantasyProsLogo from "../assets/fantasyPros.png";
import rotoBallerLogo from "../assets/rotoBaller.png";
import mySportsFeedsLogo from "../assets/mySportsFeeds.png";

export const sources = [
  {
    id: 1,
    name: "FantasyPros",
    image: fantasyProsLogo,
    width: "100px", //I put here this values because for because now its the same for all img source, but for sure we are going to want to change them differently with sizes
    height: "25px",
  },
  {
    id: 2,
    name: "MySportsFeeds",
    image: mySportsFeedsLogo,
    width: "100px",
    height: "25px",
  },
  {
    id: 3,
    name: "RotoBaller",
    image: rotoBallerLogo,
    width: "100px",
    height: "25px",
  },
];
